import React, { useState } from 'react';
import { formatCurrency, formatDate } from '../../utils/formatters';
import './ReportView.css';

const ReportView = ({ report }) => {
  const [expanded, setExpanded] = useState({ identity: true, income: true, credit: false, references: false, exceptions: true, decision: true });

  const toggle = (section) => setExpanded(prev => ({ ...prev, [section]: !prev[section] }));

  if (!report) return <div className="report-view loading">Loading report...</div>;

  return (
    <div className="report-view card print-friendly">
      <div className="card-header report-header">
        <div className="report-meta">
          <h1>Verification Report</h1>
          <p><strong>Property:</strong> {report.propertyAddress}</p>
          <p><strong>Applicant:</strong> {report.maskedName}</p>
          <p><strong>Rent:</strong> {formatCurrency(report.rent)}</p>
        </div>
        <div className="report-info">
          <p><strong>Version:</strong> {report.version}</p>
          <p><strong>Generated:</strong> {formatDate(report.generatedAt)}</p>
          <p><strong>Valid Until:</strong> {formatDate(report.validUntil)}</p>
        </div>
      </div>
      <div className="card-body">
        <div className="accordion-section">
          <button className="accordion-header" onClick={() => toggle('identity')} aria-expanded={expanded.identity}>
            <h3>1. Identity Verification</h3>
            <span>{expanded.identity ? '−' : '+'}</span>
          </button>
          {expanded.identity && (
            <div className="accordion-content">
              <p><strong>Method:</strong> {report.identity.method}</p>
              <p><strong>Result:</strong> {report.identity.result}</p>
              <p><strong>Notes:</strong> {report.identity.notes}</p>
              <p className="freshness-indicator">Source Date: {formatDate(report.identity.sourceDate)}</p>
            </div>
          )}
        </div>

        <div className="accordion-section">
          <button className="accordion-header" onClick={() => toggle('income')} aria-expanded={expanded.income}>
            <h3>2. Income & Affordability</h3>
            <span>{expanded.income ? '−' : '+'}</span>
          </button>
          {expanded.income && (
            <div className="accordion-content">
              <p className="disclaimer-text">Note: These calculations are for guidance only.</p>
              <table className="report-table">
                <tbody>
                  <tr><td>Declared Gross:</td><td>{formatCurrency(report.income.declaredGross)}</td></tr>
                  <tr><td>Verified Gross:</td><td>{formatCurrency(report.income.verifiedGross)}</td></tr>
                  <tr><td>Gross Rent-to-Income:</td><td>{report.income.grossRatio != null ? `${report.income.grossRatio}%` : '—'} <em>(Rent ÷ Verified Gross)</em></td></tr>
                  <tr><td>Net Rent-to-Income:</td><td>{report.income.netRatio != null ? `${report.income.netRatio}%` : '—'} <em>(Rent ÷ Verified Net)</em></td></tr>
                </tbody>
              </table>
              <p className="freshness-indicator">Calculation Date: {formatDate(report.income.calcDate)}</p>
            </div>
          )}
        </div>

        <div className="accordion-section">
          <button className="accordion-header" onClick={() => toggle('credit')} aria-expanded={expanded.credit}>
            <h3>3. Credit Overview</h3>
            <span>{expanded.credit ? '−' : '+'}</span>
          </button>
          {expanded.credit && (
            <div className="accordion-content">
              <p className="restricted-text">Credit data is restricted to consented recipients only.</p>
              <p><strong>Summary:</strong> {report.credit.summary}</p>
              <p><strong>Indicators:</strong> {report.credit.indicators}</p>
              <p><em>Dispute Route: Contact {report.credit.provider} directly for disputes.</em></p>
            </div>
          )}
        </div>

        <div className="accordion-section">
          <button className="accordion-header" onClick={() => toggle('exceptions')} aria-expanded={expanded.exceptions}>
            <h3>4. Exceptions & Flags</h3>
            <span>{expanded.exceptions ? '−' : '+'}</span>
          </button>
          {expanded.exceptions && (
            <div className="accordion-content">
              {report.exceptions.length > 0 ? (
                <ul className="exception-list">
                  {report.exceptions.map((ex, i) => <li key={i}>{ex.description}</li>)}
                </ul>
              ) : <p>No exceptions found.</p>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ReportView;
